import { render, staticRenderFns } from "./teamRecord.vue?vue&type=template&id=11a511fe&scoped=true"
import script from "./teamRecord.vue?vue&type=script&lang=js"
export * from "./teamRecord.vue?vue&type=script&lang=js"
import style0 from "./teamRecord.vue?vue&type=style&index=0&id=11a511fe&prod&lang=less"
import style1 from "./teamRecord.vue?vue&type=style&index=1&id=11a511fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a511fe",
  null
  
)

export default component.exports